import { css } from 'styled-components';
import token from 'styled-token';
import { mediaBreakpointMixin } from '../mediaBreakpointMixin';
import { FlexMixin } from './FlexMixin';
export var PageContentMixin = function PageContentMixin(props) {
  return token({
    maxWidth: 'Page.maxWidth',
    horizontalPadding: 'Page.horizontalPadding',
    horizontalPaddingMobile: 'Page.horizontalPaddingMobile',
    verticalMargin: 'Page.verticalMargin'
  }, function (tokens) {
    return css(["box-sizing:content-box;max-width:", ";margin:", "px auto;padding-left:", "px;padding-right:", "px;@media ", "{padding-left:", "px;padding-right:", "px;}", ""], props.fluid ? 'none' : tokens.maxWidth + "px", tokens.verticalMargin, tokens.horizontalPadding, tokens.horizontalPadding, mediaBreakpointMixin('sm_lte')(props), tokens.horizontalPaddingMobile, tokens.horizontalPaddingMobile, FlexMixin(props));
  })(props);
};